module.exports = __webpack_public_path__ + "static/media/villa-branco-3.b4ba38ad.webp";